import * as React from 'react';
import classNames from 'classnames';
import { UIText2 } from '@cian/ui-kit';

import { useDeviceCondition } from '../../../../hooks';

import { arrowDownIcon } from './icons';
import * as styles from './WithoutServicesScreen.css';

export const WithoutServicesScreen = () => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(rootStyle, styles['wrapper'])}>
      <div className={styles['icon']}>{arrowDownIcon}</div>
      <UIText2>Ваше объявление будет ниже других в поиске</UIText2>
    </div>
  );
};
